import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ErrorPage from 'yoda-site-components/lib/components/ErrorPage/ErrorPage';
import selectSolarCallStatus from '../../selectors/SolarCallStatus';
import BreadCrumbs from '../GalleryBreadCrumbs/IrisBreadCrumbsLazy';
import GalleryTitleComponent from '../GalleryTitle/GalleryTitle';
import { selectGallery } from '../../selectors/fromState';
import GalleryGridComponent from '../GalleryGrid/GalleryGrid';
import NoBrandPageResults from '../NoBrandResults/NoBrandResults';
import { isBrandPage } from '../../utils';

import * as styles from './FailOverLayout.css';

const defaultProps = {
    pageType: '',
};

const propTypes = {
    pageType: PropTypes.string,
};

const FailOverLayout = ({ pageType }) => {
    // in case of solar service success and iris failed
    /* istanbul ignore next */
    const solarCallStatusSuccess = useSelector((state) => selectSolarCallStatus(state));
    const isGalleryCallCompleted = useSelector((state) => selectGallery(state));
    if (!solarCallStatusSuccess && isGalleryCallCompleted) {
        if (isBrandPage()) {
            return <NoBrandPageResults />;
        }
        return <ErrorPage />;
    }
    return (
        <div className={['bg-white-100', 'font-open-sans', 'mx-2 my-0'].join(' ')}>
            <BreadCrumbs className={styles['breadcrumbs-container']} />
            <GalleryTitleComponent pageType={pageType} />
            <GalleryGridComponent />
        </div>
    );
};

FailOverLayout.defaultProps = defaultProps;

FailOverLayout.propTypes = propTypes;

export default FailOverLayout;
